<template>
  <div class="ride-list">
    <div v-if="detailsToggle" :style="`height: ${contentHeight}px; overflow: auto;`">
      <div v-if="rides.length">
        <div v-for="(ride, index) in rides" :key="`ride-${index}`">
          <Card :ride="ride" @rideEvent="rideEvent" />
        </div>
      </div>

      <EmptyState v-else @changeTab="changeTab" />
    </div>

    <RideDetails
      v-else
      :ride="activeRide"
      @rideEvent="rideEvent"
      @handleDetailsToggle="handleDetailsToggle"
    />
  </div>
</template>

<script>
import { calcContentHeight } from 'utils/functions'
import Card from 'components/newWebCall/drawer/rideList/card'
import EmptyState from 'components/newWebCall/drawer/rideList/EmptyState'
import RideDetails from 'components/newWebCall/drawer/rideList/rideDetails'

export default {
  name: 'RideList',
  props: {
    rides: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: Number,
      default: 0
    },
    activeRide: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Card,
    EmptyState,
    RideDetails
  },
  data () {
    return {
      contentHeight: null,
      detailsToggle: true
    }
  },
  methods: {
    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    changeTab (tab) {
      this.$emit('changeTab', tab)
    },

    rideEvent ({ event, ride, rideId }) {
      if (event === 'viewDetails') {
        this.handleDetailsToggle()
      }

      this.$emit('rideEvent', { event, ride, rideId })
    },

    handleDetailsToggle () {
      this.detailsToggle = !this.detailsToggle
    },

    resetMap () {
      this.$emit('resetMap')
    }
  },
  watch: {
    activeTab () {
      setTimeout(() => {
        this.detailsToggle = true
      }, 500)
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>
